export default () => {
  return (
    <svg
      width="17px"
      height="17px"
      viewBox="0 0 17 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Icon / Close</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M0.408403466,16.5915965 C0.964779217,17.1479723 1.50905139,17.1358771 2.04123671,16.5553114 L8.49999933,10.1691191 L14.9587619,16.5553114 C15.4909477,17.1358771 16.0352185,17.1479723 16.5915975,16.5915965 C17.1479719,16.0352208 17.1358776,15.4909486 16.55531,14.9587633 L10.1691178,8.50000067 L16.55531,2.04123806 C17.1358776,1.50905227 17.1479719,0.964781492 16.5915975,0.40840249 C16.0352185,-0.147971868 15.4909477,-0.135877581 14.9587619,0.444689996 L8.49999933,6.83088224 L2.04123671,0.444689996 C1.50905139,-0.135877581 0.964779217,-0.147971868 0.408403466,0.40840249 C-0.147972285,0.964781492 -0.135877069,1.50905227 0.444688649,2.04123806 L6.8308809,8.50000067 L0.444688649,14.9587633 C-0.135877069,15.4909486 -0.147972285,16.0352208 0.408403466,16.5915965 Z"
          id="path-1"
        />
      </defs>
      <g
        id="Desktop"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Add-Word-:-Overlay-:-Desktop"
          transform="translate(-1027.000000, -301.000000)"
        >
          <g id="Icon-/-Close" transform="translate(1027.000000, 301.000000)">
            <g id="Color-/-Grey">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1" />
              </mask>
              <use id="Mask" fill="#9B9B9B" xlink:href="#path-1" />
              <g id="Color-/-White" mask="url(#mask-2)" fill="#FFFFFF">
                <rect id="Rectangle" x="0" y="0" width="17" height="17" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/assets/images/close-icon.js